document.addEventListener("DOMContentLoaded", function() {
  // Intersection Observer for FadeIn
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: "0px 0px -50px 0px" });

  document.querySelectorAll('.fade-in-element').forEach((el) => {
    observer.observe(el);
  });
});